<template>
    <div>
        <div class="product-selectors" v-if="products && products.length > 0">
            <div class="selector-container"
                :class="result === 1 ? 'status-compatible' : (result === -1 ? 'status-incompatible' : 'status-revision')">
                <div class="product-title">Producto:</div>
                <div class="product-name">{{ selectedFirstProduct.name }}</div>
            </div>

            <div class="selector-container"
                :class="result === 1 ? 'status-compatible' : (result === -1 ? 'status-incompatible' : 'status-revision')">
                <div class="product-title">Producto:</div>
                <div class="product-name">{{ selectedSecondProduct.name }}</div>
            </div>
        </div>

        <div class="toggle-container">
            <button class="btn btn-outline-primary btn-sm" @click="iframesVisible = !iframesVisible">
                {{ iframesVisible ? 'Ocultar FDS' : 'Mostrar FDS' }}
            </button>
        </div>

        <div class="iframe-container" v-if="iframesVisible">
            <div class="iframe-wrapper">
                <iframe v-if="selectedFirstProduct.attachments"
                    :src="selectedFirstProduct.attachments + '#toolbar=1&navpanes=1&scrollbar=1'" type="application/pdf"
                    allowfullscreen></iframe>
                <div v-else class="no-document">
                    No hay documento para visualizar
                </div>
            </div>
            <div class="iframe-wrapper">
                <iframe v-if="selectedSecondProduct.attachments"
                    :src="selectedSecondProduct.attachments + '#toolbar=1&navpanes=1&scrollbar=1'"
                    type="application/pdf" allowfullscreen></iframe>
                <div v-else class="no-document">
                    No hay documento para visualizar
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Comparison',
    props: {
        products: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            iframesVisible: true,
            selectedFirstProduct: {},
            selectedSecondProduct: {},
            result: null
        };
    },
    mounted() {
        if (this.products && this.products.length > 1) {
            this.selectedFirstProduct = this.products[0]
            this.selectedSecondProduct = this.products[1]
            this.result = this.products[0].result
        }
    }

};

</script>

<style scoped>
.product-selectors {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    gap: 10px;
}

.selector-container {
    flex: 1;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #dee2e6;
    min-width: 0;
    max-width: 50%;
    display: flex;
    flex-direction: column;
}

.product-title {
    font-weight: bold;
    margin-bottom: 5px;
    color: #495057;
}

.product-name {
    font-size: 0.95rem;
    color: #212529;
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    overflow: hidden;
    width: 100%;
    display: block;
}

.toggle-container {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
}

.iframe-container {
    display: flex;
    width: 100%;
    gap: 10px;
    flex-direction: row;
}

.iframe-wrapper {
    flex: 1;
    min-height: 500px;
    border: 1px solid #ddd;
    display: flex;
    justify-content: center;
    align-items: center;
}

iframe {
    height: 100%;
    width: 100%;
    min-height: 500px;
}

.no-document {
    padding: 20px;
    text-align: center;
    color: #666;
}

.status-compatible {
    background-color: #d4edda;
    color: #155724;
}

.status-incompatible {
    background-color: #f8d7da;
    color: #721c24;
}

.status-revision {
    background-color: #fff3cd;
    color: #856404;
}

.status-compatible:hover {
    background-color: #c3e6cb;
    border-color: #b1dfbb;
}

.status-incompatible:hover {
    background-color: #f5c6cb;
    border-color: #f1b0b7;
}

.status-revision:hover {
    background-color: #ffeeba;
    border-color: #ffdf7e;
}

@media (max-width: 768px) {
    .product-selectors {
        flex-direction: column;
    }

    .selector-container {
        max-width: 100%;
        width: 100%;
    }

    .product-name {
        width: 100%;
        max-width: 100%;
    }

    .iframe-container {
        flex-direction: column;
    }

    .iframe-wrapper {
        min-height: 400px;
    }

    iframe {
        min-height: 400px;
    }
}
</style>
